import * as React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './styles/global.css';

const container = document.getElementById('root');
if (!container) {
    throw new Error('Root container #root not found in index.html.');
}

createRoot(container).render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
);
